// JavaScript source code
import React, { useState, useEffect } from 'react';
import { useParams, Link, useNavigate} from 'react-router-dom';
import SubHeader from '../components/subheader';
import SubFooter from '../components/subfooter';
import LeftNav from '../components/leftnav';
import LoginDialog from '../components/loginDialog';
import LoadingOverlay from '../components/loadingOverlay';
import MessageDialog from '../components/messageDialog';
import Cart from '../components/cart';
import { get, getUser, getCart } from '../request';
import moment from 'moment';
import config from '../config';
function MyPoint(props) {
    const activeIndex = 5;
    let params = useParams();
    const [errorMessage, setErrorMessage] = useState("");
    const navigate = useNavigate();
    const [isShowLogin, setIsShowLogin] = useState(false);
    const [isLoading, setShowLoading] = useState(false);
    const [cartlist, setCartlist] = useState([]);

    var user = getUser();
    const [list, setList] = useState([{
        unUsedPointValue: 0,
        totalPointValue: 0,
        usedPointValue:0
    }]);
    const [item, setItem] = useState({
        unUsedPointValue: 0,
        totalPointValue: 0,
        usedPointValue: 0
    });
    const [screenSize, setScreenSize] = useState(window.innerWidth);
    useEffect(() => {
        const handleResize = () => {
            setScreenSize(window.innerWidth);
        };
        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);
    useEffect(() => {
        if (user == null || user.userType != 1) {
            setIsShowLogin(true);
            //history.goBack();
        }
        else if (user.business.businessStatus != 0) {
            setErrorMessage("签署正式入驻合同后，可使用我的德联！");
            //history.goBack();
        }
        else {
            fetchData();
            getCart().then(function (response) {
                if (response.statusCode !== 200) {
                    setErrorMessage("请重新登录！");
                    setIsShowLogin(true);
                    return;
                }
                setCartlist(response.items.filter(function (c) { return c.sku; }));
            });
        }
    }, []);

    const fetchData = () => {
        setShowLoading(true);
        get('delianapi/businessorderpoint/GetBusinessOrderPointsByBusinessId').then((response) => {
            if (response.statusCode !== 200 ) {
                return;
            }
            var list = response.items;
            if (list.length >0) {
                setItem(list[0]);
            }
            setList(list);
            setShowLoading(false);
        });        

    };
    const finishLogin = () => {
        setIsShowLogin(false);
        //navigate("/JoinUsStep");
        user = getUser();
    }
    return (      
        <div className="mydelian myPoint" >
            <SubHeader activeIndex={activeIndex} user={user} setIsShowLogin={setIsShowLogin}/>
            <div className="content">
                <div className="detail" >
                    <LeftNav type={2} selectId={221} />                    
                            <div className="myContent">
                                <div className="title"> 我的积分 </div>
                                <div className="pointDetail">
                                    <div className="total">
                                        <div className="totalPoint">
                                            <div className="pointTitle">
                                                累计获得积分
                                            </div>
                                            <div className="point">
                                                {item.totalPointValue}
                                            </div>
                                        </div>
                                        <div className="totalPoint usedPoint">
                                            <div className="pointTitle">
                                                累计使用积分
                                            </div>
                                            <div className="point">
                                                {item.usedPointValue}
                                            </div>
                                        </div>
                                        <div className="totalPoint unUsedPoint">
                                            <div className="pointTitle">
                                                未提取积分
                                            </div>
                                            <div className="point">
                                                {item.unUsedPointValue}
                                            </div>
                                        </div>
                                    </div>
                           
                                {
                                screenSize > 991 ? (
                                    <div className="integraltable" >
                                        <table>
                                            <thead>
                                                <tr>
                                                    <th>时间</th>
                                                    <th>说明</th>
                                                    <th>积分</th>
                                                    <th>操作人</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {list.map((item, index) => (
                                                    <tr key={index}>
                                                        <td width="200px">
                                                            <span>{moment(item.pointDate).format("YYYY-MM-DD HH:mm:ss")}</span>
                                                        </td>
                                                        <td>
                                                            <span className="">{item.pointMemo}</span>
                                                        </td>
                                                        <td width="170px">
                                                            <span className={item.pointValue * item.pointType >= 0 ? "green" : "red"}>{item.pointValue * item.pointType}</span>
                                                        </td>
                                                        <td width="147px">
                                                            <span className="">{item.operationUserName}</span>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                    ) : (
                                        <div className="integraltable" >
                                            {list.map((item, index) => (
                                                <div key={index} className="integraltableItem ">
                                                    <div className="integraltableItemTitle ">
                                                        <span className="useName">{item.operationUserName}</span>
                                                        <span className={item.pointValue * item.pointType >= 0 ? "green" : "red"}>{item.pointValue * item.pointType}</span>
                                                    </div>
                                                    <div className="pointMemo ">
                                                        <span >{item.pointMemo}</span>
                                                        <span className="pointDate">{moment(item.pointDate).format("YYYY-MM-DD HH:mm:ss")}</span>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                )
                                }                                   
                                </div>
                            </div>
                      
                        
                    
                </div>
            </div>
            {
                cartlist &&
                <Cart num={cartlist.length} />
            }
            <SubFooter />
            <LoginDialog isShowLogin={isShowLogin} onCancel={finishLogin} />
            <MessageDialog message={errorMessage} onCancel={() => {
                setErrorMessage("");
                navigate(-1);
            }} />
            <LoadingOverlay isLoading={isLoading}>
            </LoadingOverlay>
        </div>
          
    );
}

export default MyPoint;